import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count", "status", "counter"]

  connect() {
    this.inputTargets.forEach(input => {
      this.updateCount(input)
    })
  }

  update(event) {
    this.updateCount(event.target)
  }

  updateCount(input) {
    const length = input.value.length
    const min = parseInt(input.dataset.min)
    const max = parseInt(input.dataset.max)
    
    // Find the corresponding counter elements
    const counter = input.parentElement.querySelector('[data-character-counter-target="counter"]')
    if (!counter) return
    
    const countSpan = counter.querySelector('[data-character-counter-target="count"]')
    const statusSpan = counter.querySelector('[data-character-counter-target="status"]')
    
    if (countSpan) {
      countSpan.textContent = length
    }
    
    if (statusSpan) {
      if (length < min) {
        statusSpan.textContent = `(${min - length} more needed)`
        statusSpan.className = 'text-red-600'
        counter.className = 'text-sm text-red-600'
      } else if (length > max) {
        statusSpan.textContent = `(${length - max} over limit)`
        statusSpan.className = 'text-red-600'
        counter.className = 'text-sm text-red-600'
      } else {
        statusSpan.textContent = '✓'
        statusSpan.className = 'text-green-600'
        counter.className = 'text-sm text-green-600'
      }
    }
  }
}
